import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { translate } from 'react-translate';
import { CardTitle } from 'reactstrap';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Container,
  Col,
  Input,
  Button,
} from 'reactstrap';

import { useForm } from 'react-hook-form';
import { useTranslate } from 'react-translate';
import * as yup from 'yup';
import AuthPatientsService from 'services/AuthPatientsService';
import LoadingLocal from 'plugins/TS-lib-utils-public/components/Loading/LoadingLocal';
import { ConfirmDialog, toast } from 'components/ds';

const PasswordChangeVerificationPage = (props) => {
  const { t } = props;

  const { hash } = useParams();

  const [loading, isLoading] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [submitting, isSubmitting] = useState(false);
  const [hashInfo, setHashInfo] = useState([]);

  //Form logic
  const schema = yup.object().shape({
    password: yup.string().required(t('error-required-password')).min(6, t('error-required-length')),
    rePassword: yup.string().oneOf([yup.ref('password'), null], t('error-password-not-equal')),
  });

  const { register, handleSubmit, errors } = useForm({
    validationSchema: schema,
    mode: 'onBlur',
  });

  const fetchToken = async (history, hashData) => {
    const res = await AuthPatientsService.verifyHash(hashData[0], hashData[1], hashData[2]);
    if (!res || res.status >= 400) {
      history.replace("/auth/");
    } else {
      isLoading(false);
    }
  }

  useEffect(() => {
    if (hash) {

      const hashData = hash
      ? decodeURIComponent(escape(atob(hash))).split(':')
      : null;

      if (hashData) {
        setHashInfo(hashData);
        fetchToken(props.history, hashData);
      } else {
        history.replace("/auth/");
      }
    }
  }, [hash]);


  //User confirmed the operation
  const onSubmit = async (data) => {

    //Calling
    isSubmitting(true);

    const res = await AuthPatientsService.confirmPasswordHashRequest(data.password, data.rePassword, hashInfo[0], hashInfo[1], hashInfo[2]);
    if (!res || res.status >= 400) {
      toast.error("Error confirming the changes");
      console.log("Error");
      isSubmitting(false);
    } else {
      props.history.replace("/auth/");
      isSubmitting(false);
    }
  }

  //User cancelled the operation
  const onConfirm = async () => {
    const res = await AuthPatientsService.cancelHashRequest(hashInfo[0], hashInfo[1], hashInfo[2]);
    if (!res || res.status >= 400) {
      toast.error("Error confirming the changes");
      console.log("Error");
      isSubmitting(false);
    } else {
      props.history.replace("/auth/");
      isSubmitting(false);
    }
  };

  if (loading) {
    return <LoadingLocal />
  }

  return (
    <>
      <ConfirmDialog
        isOpen={confirmOpen}
        title={t('are-you-sure-you-want-to-cancel')}
        confirmLabel={t('btn-yes')}
        cancelLabel={t('btn-no')}
        variant="primary"
        onConfirm={onConfirm}
        onCancel={() => {
          setConfirmOpen(false);
        }}
      />

      <Container>
        <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
          <Card className="card-login card-plain">

            <form className="ds-auth__form" onSubmit={handleSubmit(onSubmit)}>

              <CardHeader className="login-title">
                <img src={'/General/login/logo.svg'} width="100%" alt="" />
                <CardTitle className="text-info">{t("password-update")}</CardTitle>
              </CardHeader>

              <CardBody>
                <p>{t("password-description")}</p>

                <Input
                  name="password"
                  type="password"
                  label={t('new-password-placeholder')}
                  placeholder={t('new-password-placeholder')}
                  innerRef={register}
                  error={errors.password?.message}
                />
                <br/>

                <Input
                  name="rePassword"
                  type="password"
                  label={t('repeat-password-placeholder')}
                  placeholder={t('repeat-password-placeholder')}
                  innerRef={register}
                  error={errors.rePassword?.message}
                />
              </CardBody>

              <CardFooter className="d-flex justify-content-between">
                <Button
                  type="submit"
                  color="info"
                  size="md"
                  disabled={submitting}
                >
                  {t('send-btn')}
                </Button>

                <Button
                  type="cancel"
                  color="primary"
                  size="md"
                  disabled={submitting}
                  onClick={(e) => {
                    e.preventDefault();
                    setConfirmOpen(true);
                  }}
                >
                  {t('cancel-btn')}
                </Button>
              </CardFooter>
            </form>
          </Card>
        </Col>
      </Container>
    </>
  );
};

export default translate('request-page')(PasswordChangeVerificationPage);
